module.exports = __webpack_public_path__ + "static/img/case5-bg.0e83472.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/homePage/case5-bg.webp
// module id = thFM
// module chunks = 0